// Auto-generated by scripts/generateEnvConfig.js for the "prod" build environment.
// Do not edit by hand - regenerated on every `npm run build`.
export const API_BASE_URL = 'https://api.impelsys.com/tms/';
export const ASSET_URL = 'https://api.impelsys.com/uploads/assets/';
export const IMAGE_URL = 'https://api.impelsys.com';
